//
// Хук для определения того, находится ли экспонент или активность в избранном
//
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const useFavorites = ({ type, object }) => {
    const list = useSelector(state => state.favorites.list);
    const [ inFav, setInFav ] = useState(false);

    useEffect(() => {
        let where;
        let event_id = typeof object.event === 'string' ? object.event : object.event._id;

        switch(type) {
            case 'activity':
                where = 'activities';
                break;
            case 'exhibitor':
                where = 'exhibitors';
                break;
            default:
                setInFav(false);
                return;
        }

        if(!list[event_id]) {
            setInFav(false);
            return;
        }

        const index = list[event_id][where].findIndex(item => item._id === object._id);
        setInFav(index >= 0);
    }, [ list, object, type ]);

    return inFav;
};

useFavorites.propTypes = {
    type: PropTypes.oneOf(['exhibitor','activity']).isRequired,
    object: PropTypes.object.isRequired,
};

export default useFavorites;
